import React, { useCallback, useEffect, useState } from 'react'
import Grid from '@mui/material/Grid2';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiService } from '../../services/apiService';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-regular-svg-icons';
function SeekerProfile() {
    const id = localStorage.getItem('userid');
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [profiles, setProfile] = useState([]);
    const [profiles2, setProfile2] = useState([]);
    const [profiles3, setProfile3] = useState([]);
    const [profiles4, setProfile4] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [btnloading, setBtnLoading] = useState(false);
    // State for roles and form data
    const [formData, setFormData] = useState({
        password: '',
        password_confirmation: '',
        current_password: '',
    });
    const [preview, setPreview] = useState(null);
    const [errors, setErrors] = useState({});
    const [passwordVisible, setPasswordVisible] = useState(false);
    const [passwordVisible1, setPasswordVisible1] = useState(false);
    const [passwordVisible2, setPasswordVisible2] = useState(false);
    const [errorsmessage, setErrorsMessage] = useState('');   

    // Fetch user data when the component mounts or the user ID changes
    
    const fetchUserData = useCallback(async () => {
        setLoading(true);
        try {
            const response = await apiService.getRequest(`/admin/jobseeker/${id}`);
            if (response.success === true){
                setProfile(response.data);
                setPreview(response.data.profile);
                if(response.data.immigration_data.length !== 0){
                    setProfile2(response.data.immigration_data);
                }
                if(response.data.emergency_contact.length !== 0){
                    setProfile3(response.data.emergency_contact);
                }
                if(response.data.referral_info.length !== 0){
                    setProfile4(response.data.referral_info);
                }
            }else{
                toast.error("Retry")
            }
        } catch (error) {
            console.error("Error fetching user data", error);
        }finally {
            setLoading(false);
        }
    }, [id]);
    useEffect(() => {
        fetchUserData();
    }, [fetchUserData]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setFormData({ ...formData, profile: file });
            const reader = new FileReader();
            reader.onloadend = () => setPreview(reader.result);
            reader.readAsDataURL(file);
        }
    };
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };
    const validate = () => {
        const newErrors = {};
        if(formData.password.length > 0 || formData.current_password.length > 0 || formData.password_confirmation.length > 0 ){
            if (formData.password !== formData.password_confirmation) newErrors.password_confirmation = 'Passwords do not match';
            if (formData.current_password.length <= 0) newErrors.current_password = 'Current Passwords is required';
            if (formData.password.length <= 0) newErrors.password = 'New Passwords is required';
            if (formData.password_confirmation.length <= 0) newErrors.password_confirmation = 'Confirm Password is required';
            if (
                formData.current_password &&
                formData.password &&
                formData.current_password === formData.password
            ) {
                newErrors.password = 'New password cannot be the same as old password';
            }
        }
            setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;
        setBtnLoading(true);

        const passwordFormat = /^(?=.*[A-Z])(?=.*[a-z])(?=.*\d)(?=.*[!@#$%^&*()\-_=+\\|{};:/?.<>])[\w!@#$%^&*()\-_=+\\|{};:/?.<>]{8,}$/;
    
    // Check if the password matches the format
    if (formData.password && !passwordFormat.test(formData.password)) {
        setErrors(prevErrors => ({
            ...prevErrors,
            password: 'Password must be at least 8 characters long, include an uppercase letter, a number, and a special character.',
        }));
        setBtnLoading(false);
        return; // Exit the function if password is invalid
    }
        try {
            const dataToSubmit = {
                ...formData,
            };
            
            const formDataToSend = new FormData();
            
            Object.entries(dataToSubmit).forEach(([key, value]) => {
                formDataToSend.append(key, value);
            });

            const response = await apiService.postRequest('/update-profile', formDataToSend, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            if (response && response.success){
                fetchUserData();
                setEditMode(false);
                setErrorsMessage("");
                setFormData({
                    current_password: '',
                    password: '',
                    password_confirmation: '',
                });
                toast(response.message || 'Updated successfully!');
            }else{
                setErrors(response.errors || "");
                setErrorsMessage(response.message || "Failed to update user.");
                    if(response && response.authenticate === false){
                    await apiService.postRequest('/auth/logout');
                    localStorage.clear();
                    sessionStorage.clear();
                    window.location.href = '/login';
                }
            }
        } catch (error) {
            console.error("Error updating user data", error);
        }finally {
            setBtnLoading(false);
        }
    };

    // Toggle password visibility
    const togglePasswordVisibility = () => {
        setPasswordVisible(!passwordVisible);
    };
    const togglePasswordVisibility1 = () => {
        setPasswordVisible1(!passwordVisible1);
    };

    const togglePasswordVisibility2 = () => {
        setPasswordVisible2(!passwordVisible2);
    };
  return (
    <div className='container-fluid px-0'>
        <div className='content_container'>
            <Grid size={{xs:12}} container className="main_jobseeker">
                <Grid size={{xs:12}} container alignItems="center" justifyContent="center">
                    <Grid size={{md:12,xs:12}} container alignItems="flex-start" justifyContent="space-between" flexDirection="row" className="jobseekerhead">
                        <h3>Profile</h3>
                    </Grid>
                    <Grid size={{md:12,xs:12}} container justifyContent="flex-end" className="gap-3">
                        { !editMode ? 
                        <button className='registersendbtn2 my-0' onClick={()=> setEditMode(true)}>Edit</button> :
                        <button className='registersendbtn1 my-0' onClick={()=> setEditMode(false)}>Cancel</button> }
                        <button className='registersendbtn1 my-0' onClick={() => navigate(-1)}>Back</button>
                    </Grid>
                    {loading ? 
                    <div className='d-flex justify-content-center w-100'>
                        <img style={{ width: "100px" }} src={require('../../assets/pinkloader.gif')} alt='Loading...' />
                    </div> :
                        <Grid size={{md:11,xs:12}} container justifyContent="space-between" className="jobseekers_profilealls my-4">
                            { !editMode ? 
                                <Grid size={{xs:12}} container justifyContent="center" className="mb-5">
                                    <div className='profile_imgshowdiv' >
                                        {profiles && profiles.profile ?
                                            <img src={profiles.profile} alt='profile'/>
                                        :<img src={require("../../assets/defaultprofile.svg").default} alt='profile'/>}
                                    </div>
                                </Grid>:
                                <Grid size={{xs:12}} container className="mb-5">
                                    <form className='row justify-content-center w-100' onSubmit={handleSubmit}>
                                        <Grid size={{ sm: 11, xs: 12 }} container justifyContent="space-between" className="add_memberfields">
                                            {/* Profile Picture Upload */}
                                            <Grid size={{ sm: 12, xs: 12 }} container flexDirection="column" alignItems="center" className="profile_uploadlab my-5">
                                                <div className="profile-upload-wrapper">
                                                    <label htmlFor="profile-upload-input" className="profile-upload-label_ineditpro">
                                                        {preview ? (
                                                            <img src={preview} alt="Profile Preview" className="profile-preview" />
                                                        ) : (
                                                            <div className="placeholder-icon">
                                                                <img src={require('../../assets/cameraicon.svg').default} alt='Upload' />
                                                            </div>
                                                        )}
                                                    </label>
                                                    <input
                                                        id="profile-upload-input"
                                                        type="file"
                                                        accept="image/*"
                                                        onChange={handleImageChange}
                                                        style={{ display: 'none' }}
                                                    />
                                                </div>
                                                <small className='mt-2'>Update Profile Picture</small>
                                                <small className='mt-2 text-danger'>Note: Recomended size 100 X 100</small>
                                                <div className='w-100'>
                                                    {errors.profile && <p style={{ color: "red" }}>{errors.profile}</p>}
                                                </div>
                                            </Grid>
                                            {/* Password */}
                                            <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="mb-4">
                                                <span>Current password</span>
                                                <div className='d-flex input_witheye'>
                                                    <input
                                                        name="current_password"
                                                        type={passwordVisible1 ? 'text' : 'password'}
                                                        value={formData.current_password}
                                                        onChange={handleInputChange}
                                                        placeholder="Abcd123#"
                                                        style={{ width: '100%', paddingRight: '40px' }}
                                                    />
                                                    <button type="button" onClick={togglePasswordVisibility1}>
                                                        {passwordVisible1 ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                    </button>
                                                </div>
                                                {errors.current_password && <p style={{ color: "red" }}>{errors.current_password}</p>}
                                            </Grid>
                                            <Grid size={{ xs: 12 }} container justifyContent="space-between">
                                                
                                                <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="mb-4">
                                                    <span>New Password</span>
                                                    <div className='d-flex input_witheye'>
                                                        <input
                                                            name="password"
                                                            type={passwordVisible ? 'text' : 'password'}
                                                            value={formData.password}
                                                            onChange={handleInputChange}
                                                            placeholder="Abcd123#"
                                                            style={{ width: '100%', paddingRight: '40px' }}
                                                        />
                                                        <button type="button" onClick={togglePasswordVisibility}>
                                                            {passwordVisible ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                        </button>
                                                    </div>
                                                    {errors.password && <p style={{ color: "red" }}>{errors.password}</p>}
                                                </Grid>
                                                <Grid size={{ sm: 5.5, xs: 12 }} container flexDirection="column" className="mb-4">
                                                    <span>Confirm Password</span>
                                                    <div className='d-flex input_witheye'>
                                                        <input
                                                            name="password_confirmation"
                                                            value={formData.password_confirmation}
                                                            onChange={handleInputChange}
                                                            type={passwordVisible2 ? 'text' : 'password'}
                                                            placeholder="Abcd123#"
                                                            style={{ width: '100%', paddingRight: '40px' }}
                                                        />
                                                        <button type="button" onClick={togglePasswordVisibility2}>
                                                            {passwordVisible2 ? <FontAwesomeIcon icon={faEyeSlash} /> : <FontAwesomeIcon icon={faEye} />}
                                                        </button>
                                                    </div>
                                                    {errors.password_confirmation && <p style={{ color: "red" }}>{errors.password_confirmation}</p>}
                                                </Grid>
                                            </Grid>
                                            {errorsmessage && <p style={{ color: "red", textAlign: "center" }}>{errorsmessage}</p>}
                                            <Grid size={{sm:12,xs:12}} container justifyContent="flex-end" className="gap-lg-5 gap-3 my-3">
                                                <button type="button" className='registersendbtn1 my-0' onClick={()=> setEditMode(false)}>Cancel</button>
                                                <button type="submit" className='registersendbtn2 my-0' disabled={Object.values(formData).every((value) => value === "" || value === null || value === undefined )}>{btnloading ? <img src={require('../../assets/whiteloader.gif')} alt=''/> : 'Save'}</button>
                                            </Grid>
                                        </Grid>
                                    </form>
                                </Grid>
                            }
                            <Grid size={{xs:12}} container>
                                <h4>Personal Information</h4>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>First Name</span>
                                <p>{profiles.first_name}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Last Name</span>
                                <p>{profiles.last_name}</p>
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Email Id</span>
                                <p>{profiles.email}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Date of Birth</span>
                                <p>{profiles.dob}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Gender</span>
                                <p className='capssets'>{profiles.gender}</p>
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Address</span>
                                <p className='capssets'>{profiles.address}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>City</span>
                                <p className='capssets'>{profiles.city}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>State</span>
                                <p className='capssets'>{profiles.state}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Zip Code</span>
                                <p>{profiles.zipcode}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Phone Number</span>
                                <p>{profiles.phone_number}</p>
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Why do you want to enroll with us?</span>
                                <p className='capssets'>{profiles.why_enroll}</p>
                            </Grid>
                            {profiles2 && profiles2.length === 0 ? 
                            "":<>
                            <Grid size={{xs:12}} container>
                                <h4>Immigration Information</h4>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Citizenship Status</span>
                                <p className='capssets'>{profiles2.citizenship_status}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Are you waiting for your EAD Card to Arrive?</span>
                                <p className='capssets'>{profiles2.awaiting_ead_card || "No data"}</p>
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>When did you apply for your EAD Card?</span>
                                <p className='capssets'>{profiles2.ead_card_applied_date || "No data"}</p>
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Explain your citizenship status</span>
                                <p className='capssets'>{profiles2.citizenship_explanation}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Are you legally authorized to work in United States ?</span>
                                <p className='capssets'>{profiles2.legally_authorized_to_work}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>When will your work authorization expire ?</span>
                                <p className='capssets'>{profiles2.work_authorization_expiry || "No data"}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Which year was your SSN Issued ?</span>
                                <p className='capssets'>{profiles2.ssn_issue_year || "No data"}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Upload Most Recent I94 Copy</span>
                                <a href={`${profiles2.i94_copy}`} target="_blank" rel="noopener noreferrer">View</a>
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>I hereby authorize agents of TekPossible Consulting to access and verify the authenticity of my uploaded I-94 document through the official I-94 website (https://i94.cbp.dhs.gov/I94). I understand that this verification will be conducted in accordance with applicable laws and regulations.</span>
                                <p>Yes</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Upload Proof of Work Authorization</span>
                                {profiles2 && profiles2.proof_of_work_authorization ?
                                <a href={`${profiles2.proof_of_work_authorization}`} target="_blank" rel="noopener noreferrer">View</a>
                                :" No data"}
                            </Grid>
                            {/* <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Upload Profile Picture</span>
                                {profiles2 && profiles2.profile ?
                                    <a href={`${profiles2.profile}`} target="_blank" rel="noopener noreferrer">View</a>
                                :" No data"}
                            </Grid> */}
                            </>}
                            {profiles3 && profiles3.length === 0 ?
                            "":<>
                            <Grid size={{sm:12,xs:12}} container>
                                <h4>Emergency Contact</h4>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>First Name</span>
                                <p className='capssets'>{profiles3.first_name}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Last Name</span>
                                <p className='capssets'>{profiles3.last_name}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Phone Number</span>
                                <p className='capssets'>{profiles3.phone_number}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Relationship</span>
                                <p className='capssets'>{profiles3.relation_type}</p>
                            </Grid>
                            </>}
                            {profiles4 && profiles4.length === 0 ? 
                            "":<>
                            <Grid size={{sm:12,xs:12}} container>
                                <h4>Referral Information</h4>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Referrer Phone Number</span>
                                <p className='capssets'>{profiles4.referral_phone_number}</p>
                            </Grid>
                            <Grid size={{sm:6,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>Referrer Name</span>
                                <p className='capssets'>{profiles4.referrer_name}</p>
                            </Grid>
                            <Grid size={{sm:12,xs:12}} container flexDirection="column" className="seekprof_borders">
                                <span>How do you know the referrer ?</span>
                                <p className='capssets'>{profiles4.referrer_relationship}</p>
                            </Grid>
                            </>}
                        </Grid>
                    }
                </Grid>
            </Grid>
        </div>
    </div>
  )
}

export default SeekerProfile
